/* document-load.ts|js file - the code snippet is the same for both the languages */
import {
  BatchSpanProcessor,
  WebTracerProvider,
} from "@opentelemetry/sdk-trace-web";
import { DocumentLoadInstrumentation } from "@opentelemetry/instrumentation-document-load";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { registerInstrumentations } from "@opentelemetry/instrumentation";

import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { resourceFromAttributes } from "@opentelemetry/resources";
import { v4 as uuidv4 } from "uuid";

const otlpExporter = new OTLPTraceExporter({
  url: "https://monitoring.parat-api.rodekors.dk:4318/v1/traces",
  headers: {
    "Content-Type": "application/json",
  },
  httpAgentOptions: {
    keepAlive: true,
  },
  timeoutMillis: 50000,
});

const provider = new WebTracerProvider({
  resource: resourceFromAttributes({
    "service.name": "RK Parat Universal Link",
    "deployment.environment": "Prod",
    "session.id": uuidv4(),
  }),
  spanProcessors: [
    new BatchSpanProcessor(otlpExporter, {
      maxQueueSize: 1000,
      scheduledDelayMillis: 2000,
    }),
  ],
});

provider.register({
  // Changing default contextManager to use ZoneContextManager - supports asynchronous operations - optional
  contextManager: new ZoneContextManager(),
});

// Registering instrumentations
registerInstrumentations({
  instrumentations: [new DocumentLoadInstrumentation()],
});
